
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component<ItemTags>({})
export default class ItemTags extends Vue {
	@Prop({ type: Array, required: false, default: () => [] }) private tags!: MenuItemTag[];
	@Prop({ type: Boolean, required: false, default: false }) private alwaysShowNames!: boolean;
}
